import styled from 'styled-components/macro';

export const Wrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
});

export const Icon = styled.span({
  display: 'block',
  width: '32px',
  height: '32px',
  marginRight: '10px',
  flexShrink: 0,
});
